"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertTitleStyle = exports.alertStyle = void 0;
const alertStyle = exports.alertStyle = {
  display: 'flex'
};
const alertTitleStyle = exports.alertTitleStyle = {
  textAlign: 'left'
};
